<mat-info-field>
  <div class="info-field">
    <label class="info-field__label">{{label}}</label>
    <div class="info-field__value">&nbsp;{{formattedValue}}<span *ngIf="suffix" class="info-field__value-suffix">&nbsp;{{suffix}}</span></div>
  </div>
</mat-info-field>
